module.exports = __webpack_public_path__ + "static/media/avatar-placeholder.b4163fa2.png";